'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
require('styled-components');
var select = require('./select-6c9d108c.js');
var selectItem = require('./select-item-7fd13c43.js');
var selectTitle = require('./select-title-65885e9f.js');
var nativeSelect = require('./native-select-7bedfed9.js');
require('./device.context-f96381a3.js');
var device_context_hooks = require('./device.context.hooks-0223e9f1.js');
require('./mobile-detect-2421ba00.js');

function useSelectedItem(items, selectedValue) {
    return React.useMemo(function () { return items.find(function (item) { return item.value === selectedValue; }); }, [items, selectedValue]);
}

var CustomSelect = function (_a) {
    var _b, _c;
    var className = _a.className, name = _a.name, value = _a.value, label = _a.label, items = _a.items, dataCy = _a.dataCy, otherSelectProps = tslib_es6.__rest(_a, ["className", "name", "value", "label", "items", "dataCy"]);
    var selectedItem = useSelectedItem(items, value);
    return (React__default.createElement(select.Select, tslib_es6.__assign({ className: className, selectedValueLabel: (_b = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) !== null && _b !== void 0 ? _b : '', value: (_c = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) !== null && _c !== void 0 ? _c : '', name: name, titleComponent: React__default.createElement(selectTitle.SelectTitle, { title: label }), dataCy: dataCy }, otherSelectProps), items.map(function (item) { return (React__default.createElement(selectItem.SelectItem, { key: item.value, value: item.value, renderedValue: item.label, "data-cy": dataCy + "-item-" + item.label })); })));
};

var SelectTw = function (props) {
    var isMobileDevice = device_context_hooks.useIsMobileDevice();
    if (isMobileDevice) {
        return React__default.createElement(nativeSelect.NativeSelect, tslib_es6.__assign({}, props));
    }
    return React__default.createElement(CustomSelect, tslib_es6.__assign({}, props));
};

exports.SelectTw = SelectTw;
